import { BarChartOutlined, BorderOutlined, DollarOutlined, UserOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { SellerReportPeriod } from "services/interface/sellerReport.interface";
import { paths } from "setup/PageRouter/routesConfig";
import { numberFormatInt } from "utils/nuberFormat";
import { useSellerKpi } from "hooks/useSellerReport";
import DeltaText from "../shared/DeltaText";
import KpiCard from "./KpiCard";
import { sd } from "../tokens";

interface KpiRowProps {
  period: SellerReportPeriod;
}

const KpiRow = ({ period }: KpiRowProps) => {
  const navigate = useNavigate();
  const { data, isPending, isFetching, isError } = useSellerKpi(period);

  // strictNullChecks: data เป็น undefined ได้ตลอด — ใช้ค่า default แทนการ assert
  const kpi = {
    net_sales: data?.net_sales ?? 0,
    net_sales_change_pct: data?.net_sales_change_pct ?? 0,
    order_count: data?.order_count ?? 0,
    order_count_change: data?.order_count_change ?? 0,
    withdrawable_amount: data?.withdrawable_amount ?? 0,
    withdrawable_order_count: data?.withdrawable_order_count ?? 0,
    repeat_customer_pct: data?.repeat_customer_pct ?? 0,
    repeat_customer_change_pct: data?.repeat_customer_change_pct ?? 0,
  };

  const shared = {
    loading: isPending,
    refreshing: isFetching && !isPending,
    error: isError,
  };

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={12} xl={6}>
        <KpiCard
          {...shared}
          accent
          label="ยอดขายสุทธิ"
          value={`฿${numberFormatInt(kpi.net_sales)}`}
          chipIcon={<BarChartOutlined />}
          chipBg={sd.orangeSoft}
          chipColor={sd.orange}
          delta={<DeltaText value={kpi.net_sales_change_pct} />}
        />
      </Col>
      <Col xs={24} sm={12} lg={12} xl={6}>
        <KpiCard
          {...shared}
          label="คำสั่งซื้อ"
          value={numberFormatInt(kpi.order_count)}
          unit="รายการ"
          chipIcon={<BorderOutlined />}
          chipBg={sd.blueSoft}
          chipColor={sd.blue}
          delta={<DeltaText value={kpi.order_count_change} mode="count" unit="รายการ" />}
        />
      </Col>
      <Col xs={24} sm={12} lg={12} xl={6}>
        <KpiCard
          {...shared}
          label="เงินพร้อมถอน"
          value={`฿${numberFormatInt(kpi.withdrawable_amount)}`}
          chipIcon={<DollarOutlined />}
          chipBg={sd.greenSoft}
          chipColor={sd.green}
          linkText="ดูรายละเอียด"
          onLinkClick={() => navigate(paths.manageFinance)}
        />
      </Col>
      <Col xs={24} sm={12} lg={12} xl={6}>
        <KpiCard
          {...shared}
          label="ลูกค้าซื้อซ้ำ"
          value={`${kpi.repeat_customer_pct.toFixed(0)}%`}
          chipIcon={<UserOutlined />}
          chipBg={sd.purpleSoft}
          chipColor={sd.purple}
          delta={<DeltaText value={kpi.repeat_customer_change_pct} />}
        />
      </Col>
    </Row>
  );
};

export default KpiRow;
